import { getOperationalStatus } from "@/lib/status/api";
import { OperationalStatus } from "@/types";
import { useSuspenseQuery } from "@tanstack/react-query";

export function useGetOperationalStatus() {
  return useSuspenseQuery({
    queryKey: ["status"],
    queryFn: async () => {
      try {
        return await getOperationalStatus();
      } catch (error) {
        console.error("Failed to fetch operational status:", error);
        return { data: { status: "unknown", uptime: 0 } };
      }
    },
    select: (data) => {
      try {
        return (data?.data || {
          status: "unknown",
          uptime: 0,
        }) as OperationalStatus;
      } catch (error) {
        console.error("Error in operational status select:", error);
        return { status: "unknown", uptime: 0 } as OperationalStatus;
      }
    },
    staleTime: 120000,
    refetchInterval: 120000, // Refresh every 2 minutes
  });
}
